export enum AvailabilityEnum {
	UNAVAILABLE, AVAILABLE,
}
